import React from 'react'
import {DashboardLogs} from './DashboardLogs'

const LogsManagementPage: React.FC = () => {
  return (
    <>
      <div className='mb-5 d-flex justify-content-between align-items-start'>
        <div>
          <h1 className='mb-0 fw-bold' style={{fontSize: '25px', lineHeight: '32px'}}>
            Call logs
          </h1>
        </div>
      </div>
      <div className='card mb-5'>
        <div className='card-body pt-2'>
          <DashboardLogs className='' />
        </div>
      </div>
    </>
  )
}

export {LogsManagementPage}
